<template>
  <a
    v-if="infoBanner.isImage"
    :href="infoBanner.link.href"
    :target="infoBanner.link.target"
    class="imageBanner"
    :style="backgroundImage"
  />
  <div
    v-else
    class="infoBanner"
  >
    <div class="wrap">
      <div class="title">{{ infoBanner.title }}</div>
      <a
        v-if="infoBanner.link"
        :href="infoBanner.link.href"
        :target="infoBanner.link.target"
        class="infoLink"
      >{{ $t("link.readMore") }}</a>
    </div>
  </div>
</template>

<script>
  import ImageHelpers from "utils/mixins/ImageHelpers"
  import { mapState } from "vuex"

  export default {
    name: 'InfoBanner',
    mixins: [
      ImageHelpers
    ],
    data () {
      return {
        backgroundImage: ''
      }
    },
    computed: {
      ...mapState("indexTabs", [
        "infoBanner"
      ])
    },
    created () {
      if (this.infoBanner.isImage) {
        this.getBackgroundImage()
        window.addEventListener('resize', this.getBackgroundImage)
      }
    },
    destroyed () {
      window.removeEventListener('resize', this.getBackgroundImage)
    },
    methods: {
      getBackgroundImage () {
        const source = this.$_ImageHelpers_responsiveImage({
          desktop: this.infoBanner.images.desktopImg.img,
          tablet: this.infoBanner.images.tabletImg.img,
          mobile: this.infoBanner.images.mobileImg.img
        })

        this.backgroundImage = this.$_ImageHelpers_getBackgroundImage(source)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .imageBanner {
    display: block;
    width: 100%;
    height: 80px;
    background-position: 50% 50%;
    background-size: auto 80px;
    background-repeat: repeat-x;
  }

  .infoBanner {
    margin: 0 auto;
    background: #eceef0;

    .wrap {
      display: flex;
      flex-direction: column;
      padding: 12px;

      @include bp-mf-tablet {
        max-width: $tablet-wide-width;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        padding: 18px 25px;
        min-height: 64px;
      }

      @include bp-mf-desktop {
        max-width: $desktop-wide-width;
      }
    }

    .title {
      @include defaultFontValues($blue-dark, 14, 20, 500);
      padding-right: 20px;
      position: relative;
      margin-bottom: 14px;
      display: flex;
      align-items: center;

      @include bp-mf-tablet {
        margin: 0;
        font-size: em(16);
        line-height: 24px;
      }

      &:before {
        content: $icon-alert-thin;
        @include icon-font-thin();
        display: block;
        font-size: em(21);
        color: $green-base;
        width: 38px;

        @include bp-mf-tablet {
          width: 42px;
          font-size: em(25);
        }
      }
    }

    .infoLink {
      @include defaultFontValues($blue-medium, 14, 24, 500);
      display: flex;
      justify-content: flex-end;
      text-decoration: none;

      @include bp-mf-tablet {
        font-size: em(16);
        line-height: 24px;
      }

      &:after {
        @include icon-font-thin();
        content: $icon-arrow-right-thin-medium;
        display: inline-block;
        font-size: em(9);
        color: $blue-medium;
        margin-left: 9px;
        width: 18px;

        @include bp-mf-tablet {
          margin-left: 17px;
          width: 13px;
        }
      }
    }
  }
</style>
